import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  followLink({ params: { path } }) {
    window.location.href = path;
  }
}
